import { api } from '../api';

export type TimelineEventType =
  | 'ADMISSION'
  | 'DISCHARGE'
  | 'BGT_SESSION'
  | 'VOICE_SESSION'
  | 'OUTPATIENT_VISIT'
  | 'RESIDENT_TYPE_CHANGED'
  | 'RESIDENT_ROOM_CHANGED';

export interface TimelineEvent {
  type: TimelineEventType;
  occurredAt: string;
  summary: string;
  detail?: Record<string, string | number | null>;
}

export interface ResidentTimeline {
  residentId: string;
  events: TimelineEvent[];
  outpatientVisitCount: number;
}

export async function getResidentTimeline(residentId: string): Promise<ResidentTimeline> {
  const res = await api.get<ResidentTimeline>(`/residents/${residentId}/timeline`);
  return res.data;
}
